import { render, staticRenderFns } from "./InsightMSBarChart.vue?vue&type=template&id=01166b92&scoped=true"
import script from "./InsightMSBarChart.vue?vue&type=script&lang=js"
export * from "./InsightMSBarChart.vue?vue&type=script&lang=js"
import style0 from "./InsightMSBarChart.vue?vue&type=style&index=0&id=01166b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01166b92",
  null
  
)

export default component.exports